import React from 'react';
import * as Popover from '@radix-ui/react-popover';
import { QuestionMarkCircleIcon } from '@heroicons/react/solid';

const InfoTooltip = ({ 
  content, 
  label = "More information", 
  side = "top", 
  align = "center", 
  maxWidth = "250px",
  className = ""
}) => {
  // Function to render content with line breaks
  const renderContent = () => {
    if (typeof content !== 'string') return content;
    
    // Split the content by double newlines
    const paragraphs = content.split('\n\n');
    
    // Return each section as a paragraph with bottom margin except last one
    return paragraphs.map((paragraph, index) => (
      <p key={index} className={index < paragraphs.length - 1 ? 'mb-2' : ''}>
        {paragraph}
      </p>
    ));
  };

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button 
          className={`text-primary rounded-full hover:bg-primary/10 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${className}`}
          aria-label={label}
        >
          <QuestionMarkCircleIcon className="w-4 h-4" />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content 
          className="bg-slate-900 font-semibold text-white rounded-lg p-3 text-sm shadow-lg mx-4 z-[60] info-tooltip-content"
          style={{ maxWidth }}
          sideOffset={5}
          side={side}
          align={align}
          collisionPadding={16}
        >
          <div>{renderContent()}</div>
          <style>{`
            .info-tooltip-content[data-state='open'] {
              animation: infoTooltipIn 150ms ease-out;
            }
            .info-tooltip-content[data-state='closed'] {
              animation: infoTooltipOut 100ms ease-in;
            }
            @keyframes infoTooltipIn {
              from { opacity: 0; transform: scale(0.95); }
              to   { opacity: 1; transform: scale(1); }
            }
            @keyframes infoTooltipOut {
              from { opacity: 1; transform: scale(1); }
              to   { opacity: 0; transform: scale(0.95); }
            }
          `}</style>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default InfoTooltip;